<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title  class="px-0 mx-5">

                <v-row>
                    <v-col cols="12" sm="3" md="3" class="mb-4">
                        <v-icon large left>{{icone}}</v-icon>
                        <span class="title font-weight-light">{{titulo}}</span>
                    </v-col>
                    <v-col cols="12" sm="7" md="7" class="mt-n4">
                        <v-text-field :type="tipoInput" v-if="temBuscaRapida" v-model="localBuscaRapida" @input="$emit('update:buscaRapida', localBuscaRapida)" label="Busca rápida" clearable single-linehide-details @change="Atualizar()"/>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" style="display: flex ; justify-content: space-evenly ; align-items: center ">
                        
                        <v-tooltip bottom v-if="botaoPadrao">
                            <template v-slot:activator="{ on }">
                                <v-btn icon color="click" class="mb-2" v-on="on" @click="Novo()" style="margin-top: 10px">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <span>Novo {{titulo}}</span>
                        </v-tooltip>
                        
                        <v-tooltip bottom v-if="botaoPadrao">
                            <template v-slot:activator="{ on }">
                                <v-btn icon color="click" class="mb-2" v-on="on" @click="Atualizar()" style="margin-top: 10px">
                                    <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>Atualizar</span>
                        </v-tooltip>
                        
                        <slot name="botoes"/>
                    </v-col>

                </v-row>


            </v-card-title>

            <v-card-text>
                
                <slot name="corpo"/>

            </v-card-text>
        </v-card>

    </master-page>
</template>
<script>

export default {
    props:{
        icone: '',
        titulo: '',
        buscaRapida: '',
        temBuscaRapida: false,
        tipoInput: "",
        botaoPadrao: {
            default: true
        }
    },
    data: () => ({
        localBuscaRapida: ''
    }),
    methods: {
        Novo(){
            this.$emit('novo');
        },
        Atualizar(){
            this.$emit('atualizar');
        },
        Editar(item) {
          this.item = Object.assign({}, new FechamentoMes(item))
          this.dialogCadastro = true;
        }
    }
}
</script>
<style scoped>

</style>
